class SectionCompanyQuote implements ng.IComponentController {
    username: string;
    description: string;
    text: string;
    avatar: string;
    alt: string;
}

angular.module('animatronApp.sectionCompanyQuote', []).component('sectionCompanyQuote', {
    bindings: {
        username: '<',
        description: '<',
        text: '<',
        avatar: '<',
        alt: '<'
    },
    controller: SectionCompanyQuote,
    templateUrl: require('landing-template/components/sections/section-company-quote.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/landing-template/components/sections/SectionCompanyQuote.ts